import { createAction } from 'redux-api-middleware'
import type { RootState } from '../../reducers'
import { HUBBLE_API_TOKEN } from '../../store/middleware/APIUrl'
import ActionTypes from './actionTypes'

type CreditDeleteRequest = {
    type: typeof ActionTypes.CREDIT_DELETE_REQUEST;
    payload: never;
}

type CreditDeleteFailure = {
    type: typeof ActionTypes.CREDIT_DELETE_FAILURE;
    payload: Error;
}

type CreditDeleteSuccess = {
    type: typeof ActionTypes.CREDIT_DELETE_SUCCESS;
    payload: number;
}

/**
 * Delete one credit given its ID
 */
function deleteCredit(id: number) {
    return createAction<RootState, number, never>({
        endpoint: `${HUBBLE_API_TOKEN}/credits/${id}`,
        method: 'DELETE',
        types: [
            ActionTypes.CREDIT_DELETE_REQUEST,
            {
                type: ActionTypes.CREDIT_DELETE_SUCCESS,
                payload: () => id,
            },
            ActionTypes.CREDIT_DELETE_FAILURE,
        ],
    })
}

export type CreditDeleteAction = CreditDeleteRequest
    | CreditDeleteFailure
    | CreditDeleteSuccess

export default deleteCredit
